class CharacterCountEllipsis {
  constructor(string, stringClipLength, windowWidth, mediaQueryObject) {
    this.targetString = string;
    this.originalString = string;
    this.stringClipLength = stringClipLength;
    this.ellispis = '....';
    this.requiresTrim = false;
    this.windowWidth = windowWidth;
    this.targetedElements;
    this.mediaQueryObject = mediaQueryObject ? mediaQueryObject : {};
  }
  /**
   * Simple setter for the targetString instance variable.
   */
  setString = (incomingString) => {
    this.targetString = incomingString;
  }
  /**
   * Simple getter for the targetString instance variable.
   */
  getString = () => {
    return this.targetString;
  }
  /**
   * @method getWindowSize - calculates the browser width or device screen size.
   * @return integer - returns detected size.
   */
  getWindowSize = () => {
    const windowWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    return windowWidth !== null ? windowWidth : 3;
  };
  /**
   * @method getStringLength - counts the length of a string.
   * @return integer - returns the string length as an integer.
   */
  getStringLength = () => {
    let stringLength = 0;
    stringLength = this.targetString.length;
    return stringLength;
  };
  /**
   * @method getTrimmedString - Takes a string a modifies it based on the trimLength specified in 
   * constructor.
   * @return - returns modified/ trimmed string
   */
  getTrimmedString = () => {
    
    let trimmedString = '';
    let limitLength = this.stringClipLength;
    let stringLength = this.getStringLength();
    let theWindowSize = this.getWindowSize();
    if (theWindowSize < this.windowWidth) {
      if (stringLength > limitLength) {
        this.requiresTrim = true;
        trimmedString = this.targetString.slice(0, limitLength);
      } else {
        this.requiresTrim = false;
        trimmedString = this.originalString;
      }
    } else {
      this.requiresTrim = false;
      trimmedString = this.originalString;
    }

    trimmedString = trimmedString.trim();

    return { string: trimmedString, status: this.requiresTrim }; //return trimmedString;
  };
  /**
   * @method getTrimmedStringForDevices - Adjusts the string trim settings based on screen sizes provided by argument mediaQueryObject 
   * in the constructor.
   * @return string - returns the trimmed string.
   */
  getTrimmedStringForDevices = (incomingString) => {
    let regex = '...';
    if (incomingString.match(regex)) {
      const removeDBEllipses = incomingString.replace(regex, '');
      incomingString = removeDBEllipses;
    }
    this.targetString = incomingString;
    this.originalString = incomingString;
    let modifiedString = {};
    if (this.getWindowSize() < this.mediaQueryObject.mobile) {
      this.windowWidth = this.mediaQueryObject.mobile;
      this.stringClipLength = 80;
    } else if (this.getWindowSize() > this.mediaQueryObject.mobile && this.getWindowSize() < this.mediaQueryObject.tablet) {
      this.windowWidth = this.mediaQueryObject.tablet;
      this.stringClipLength = 90;
    } else if (this.getWindowSize() > this.mediaQueryObject.tablet && this.getWindowSize() < this.mediaQueryObject.desktop) {
      this.windowWidth = this.mediaQueryObject.desktop;
      this.stringClipLength = 130;
    } else if (this.getWindowSize() > this.mediaQueryObject.desktop && this.getWindowSize() < 1921) {
      this.windowWidth = 1921;
      this.stringClipLength = 140;
    } else {
      this.windowWidth = 2048; // anything below 2k
      this.stringClipLength = 180;
    }
 
    modifiedString = this.getTrimmedString();
    modifiedString.string = this.getModifiedEllipsisString();
    return modifiedString.string;
  }
  /**
   * @method geLineCount - returns the number of new lines in a body of text
   * @return integer - number of detected lines.
   */
  getLineCount = (incomingString) => {
    const testString = incomingString;
    return testString.split(/\r\n|\r|\n/).length;
  }
  /**
   * @method addEllipsis - Adds ellipses to a string and returns it.
   * @return string - modified string
   */
  addEllipsis = (trimmedString) => {
    trimmedString = trimmedString + this.ellispis;
    return trimmedString;
  };
  /**
   * @method getModifiedEllipsisString - helps add ellipses to trimmed strings.
   * to it.
   * @return string - returns a new string that has a trailing ellipsis at the end of it.
   */
  getModifiedEllipsisString = () => {
    let finalString = '';
    let evaluatedString = this.getTrimmedString();
    finalString = this.addEllipsis(evaluatedString.string);
    return finalString;
  }

  /**
   * Remove orphan paragraph tags from elements that are built using HTML from database.
   * @param {object} elementNode - HTML object or HTML object array.
   */
  removeOrphanPTags = (elementNode) => {
    elementNode.forEach(item => {
      let itemPTag = item.querySelectorAll('p');
      itemPTag.forEach(ptext => {
        if (ptext.innerText.length === 0 || ptext.innerText === '' || ptext.innerHTML === '') {
          item.removeChild(ptext);
        }
      });
    });
  }
  /**
   * Remove <br> tags from elements that are built using HTML from database.
   * @param {object} elementNode - HTML object or HTML object array.
   */
  removeOrphanBreakTags = (elementNode) => {
    let breakTags;
    let paragraphTags;
    if (elementNode) {
      elementNode.forEach(item => {
        if (item.querySelectorAll('p').length > 0) {
          paragraphTags = item.querySelectorAll('p');
          paragraphTags.forEach(paragraph => {
            if (paragraph.querySelectorAll('br').length > 0) {
              breakTags = paragraph.querySelectorAll('br');
              breakTags.forEach(brkTag => {
                paragraph.removeChild(brkTag);
              });
            }
          });
        }
      });
    }
  }
  /**
   * @method - matchHeightOnLoad - Finds the tallest element provided in the HTML Object array and sets the rest
   * to match when the page loads.
   * @param {object} elementNode - html node or object
   */
  matchHeightOnLoad = (elementNode) => {
    let comparisonArray = [];
    elementNode.forEach(item => {
      comparisonArray.push(parseInt(getComputedStyle(item).height)); // get the computed style for category discription paragraph tags.
    });

    let generalHeight = Math.max(...comparisonArray); // find the tallest height

    elementNode.forEach(item => {
      item.style.minHeight = generalHeight + 'px'; // set every category description paragraph to the tallest height on load.
    });
  }
}

export default CharacterCountEllipsis;
